import { formatDateDayTime } from '@/utils/dates'
import { FileSubmission, getRecordTypeLabel } from '@/models/file-submission.tsx'
import Icon, { IconName } from '@/components/shared/Icon.tsx'
import { joinClasses } from '@/utils/styling';
import TooltipTrigger from '@/components/shared/TooltipTrigger.tsx'

export default function Header({ file }: { file: FileSubmission }) {
    const recordType = getRecordTypeLabel(file.RecordTypeCode),
          fileName = file.ClientFileName,
          dateSubmitted = formatDateDayTime(file.CreateDate),
          submittedBy = file.CreatedByUserId,
          recordsCount = file.InputRecords;

    const headerFirstLineItems: {
        icon: IconName;
        text: string;
        label: string;
        textClass?: string;
    }[] = [
        { icon: 'tag', text: recordType, label: 'Record type', textClass: 'fw-bold' },
        { icon: 'file', text: fileName, label: 'File name' },
        { icon: 'calendar', text: dateSubmitted, label: 'Date submitted' }
    ];

    const headerSecondLineItems: {
        text: string;
        label: string;
    }[] = [
        { text: submittedBy, label: 'Submitted by' },
        { text: recordsCount?.toString(), label: 'Records in Submission' }
    ];

    return (
        <>
            <div className="d-flex align-items-center fs-5 mb-2">
                {headerFirstLineItems.map(item => (
                    <div key={item.label} className="d-flex align-items-center pe-3" style={{ width: '33%'}}>
                        <TooltipTrigger tooltipText={item.label}>
                            <div className="me-2"><Icon name={item.icon} className="text-muted" /></div>
                        </TooltipTrigger>
                        <span className={joinClasses(item.textClass)}>{item.text}</span>
                    </div>
                ))}
            </div>
            <div className="d-flex ">
                {headerSecondLineItems.map(item => (
                    <div key={item.label} className="d-flex pe-3" style={{ width: '33%'}}>
                        <div className="text-muted me-3 mb-0 small text-nowrap pt-1">{item.label} </div>
                        <div className="text-break">{item.text}</div>
                    </div>
                ))}
            </div>
            
        </>
    )
}